import styled from 'styled-components'

const CloseIconWrapperUi = styled.div`
  display: flex;
  width: 100%;
`

export default CloseIconWrapperUi
